/* eslint-disable eqeqeq */
// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Utils
import { sendAmplitudeEvent } from '../../analytics/amplitudeService';
import { getCurrentBoard } from '../../element/selectors/currentBoardSelector';
import { getBackgroundColor } from '../../../common/elements/utils/elementPropertyUtils';

// Actions
import { updateCurrentBoardBackground } from '../../canvas/background/boardBackgroundActions';

// Components
import ColorButton from '../toolbar/components/selectionTools/colorTools/popup/ColorButton';

// Constants
import { CANVAS_COLORS } from '../../../common/colors/colorConstants';
import { EVENT_TYPE_NAMES } from '../../../common/analytics/amplitudeEventTypesUtil';
import { AMPLITUDE_USER_PROPS, TRACKED_FEATURES } from '../../../common/analytics/statsConstants';

// Styles
import './CanvasColorContextMenuItem.scss';

const mapStateToProps = createStructuredSelector({
    selectedColor: (state) => getBackgroundColor(getCurrentBoard(state)),
});

const mapDispatchToProps = (dispatch) => ({
    setColor: (color) => {
        sendAmplitudeEvent({
            eventType: EVENT_TYPE_NAMES.SET_BOARD_BACKGROUND,
            userProperties: {
                [AMPLITUDE_USER_PROPS.FEATURE]: {
                    [TRACKED_FEATURES.BOARD_BACKGROUND]: true,
                },
            },
        });

        return dispatch(updateCurrentBoardBackground({ color }));
    },
});

const CanvasColorContextMenuItem = (props) => {
    const { setColor, selectedColor } = props;

    return (
        <div className="CanvasColorContextMenuItem">
            <ul className="colors">
                {Object.keys(CANVAS_COLORS).map((color) => (
                    <li className="color-list-item" key={color} onClick={() => setColor(CANVAS_COLORS[color].name)}>
                        <ColorButton
                            color={CANVAS_COLORS[color]}
                            isActive={selectedColor == CANVAS_COLORS[color].name}
                            isContextMenu
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
};

CanvasColorContextMenuItem.propTypes = {
    setColor: PropTypes.func,
    selectedColor: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(CanvasColorContextMenuItem);
